import { ArrowRight } from "components/icons/generated";
import Icon from "ds/components/Icon";
import { EntityChangeType } from "types/generated";

import type { RunCodeChangesResolvedValue } from "../types";
import RunCodeChangesValue from "../Value";
import styles from "./styles.module.css";

type RunCodeChangesValuesProps = {
  type: EntityChangeType;
  before: RunCodeChangesResolvedValue | undefined;
  after: RunCodeChangesResolvedValue | undefined;
  afterUnknown: boolean;
};

const RunCodeChangesValues = ({ type, before, after, afterUnknown }: RunCodeChangesValuesProps) => {
  if (type === EntityChangeType.Delete) {
    return <RunCodeChangesValue resolved={before} />;
  }

  if (
    type === EntityChangeType.Change ||
    type === EntityChangeType.ReplaceCreateBeforeDestroy ||
    type === EntityChangeType.ReplaceDestroyBeforeCreate
  ) {
    return (
      <>
        <RunCodeChangesValue resolved={before} />
        <Icon src={ArrowRight} className={styles.arrow} />
        <RunCodeChangesValue resolved={after} knownAfterApply={afterUnknown} />
      </>
    );
  }

  return <RunCodeChangesValue resolved={after} knownAfterApply={afterUnknown} />;
};

export default RunCodeChangesValues;
